module.exports = __webpack_public_path__ + "root-c2082cbd/XING-Sans-Medium-Italic-ea8eff144bc4a439b3e15366b1e9dd1c.woff";